import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`To ensure the integrity of packages you download from the public npm registry, or any registry that supports signatures, you can verify the registry signatures of downloaded packages using the npm CLI.`}</p>
    <h2>{`Prerequisites`}</h2>
    <ol>
      <li parentName="ol">{`Install npm CLI version v8.15.0 or later`}</li>
      <li parentName="ol">{`Install dependencies using `}<inlineCode parentName="li">{`npm install`}</inlineCode>{` or `}<inlineCode parentName="li">{`npm ci`}</inlineCode></li>
    </ol>
    <h2>{`Verifying registry signatures`}</h2>
    <p>{`Registry signatures can be verified using the following `}<inlineCode parentName="p">{`audit`}</inlineCode>{` command:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm audit signatures
`}</code></pre>
    <p>{`Example response if all installed versions have valid registry signatures:`}</p>
    <pre><code parentName="pre" {...{}}>{`audited 1640 packages in 2s

1640 have verified registry signatures
`}</code></pre>
    <h2>{`Troubleshooting`}</h2>
    <h3>{`Some packages are missing registry signatures`}</h3>
    <p>{`The CLI will error if packages don't have signatures `}<em parentName="p">{`and`}</em>{` if the package registry supports signatures. This could mean an attacker might be trying to circumvent signature verification.
You can check if the registry supports signatures by requesting the public signing keys from `}<inlineCode parentName="p">{`registry-host.tld/-/npm/v1/keys`}</inlineCode>{`.`}</p>
    <p>{`Example response if some versions have missing registry signatures:`}</p>
    <pre><code parentName="pre" {...{}}>{`audited 1640 packages in 2s

1405 packages have verified registry signatures

235 packages have missing registry signatures but the registry is providing signing keys:

missing-dep@1.0.0 (https://registry.npmjs.org/)
...
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      